<div class="text-left text-md-center title p-3 w-100" [class]="getClassEnviroment()">
    <button mat-icon-button class="drawer-toggle" [disableRipple]="true" (click)="openSideMenuVisible ? headerService.openDrawer.emit() : headerService.closeDrawer.emit()" *ngIf="menuTriggerVisible">
        <mat-icon class="header-icon font-weight-bold">
            {{openSideMenuVisible ? 'menu' : 'keyboard_arrow_up'}}
        </mat-icon>
    </button>

    <h5 class="nomeAlbergo" (click)="openSideMenuVisible ? headerService.openDrawer.emit() : headerService.closeDrawer.emit()" *ngIf="nomeAlbergoVisible">
        <span class="app-name d-none d-lg-inline-block pr-4 mr-4">
            {{'sbm.title' | translate}}
        </span>

        <span>
            {{sessionService.getNomeAlbergo()}}
        </span>
    </h5>

    <h5 class="mt-1 d-none d-lg-block">{{ getVersione() }} </h5>

    <div class="text-right float-right language autoWidthLanguageSelectMain pr-3" [ngClass]="{'mt-n2': nomeAlbergoVisible && !!sessionService.getUtente()}">
        <mat-form-field class="languageSelectMain">
            <mat-select [(ngModel)]="currentLangId" (selectionChange)="setLanguage()" class="select" [panelClass]="'testt'">
                <mat-select-trigger>
                    <span class="fi fi-{{ currentLanguage?.flagIcon }}"></span>
                    <span class="language-name d-none d-lg-inline-block">{{('language_codes.' + currentLanguage?.codice) | translate}}</span>
                </mat-select-trigger>

                <mat-option *ngFor="let lang of localizationService.languagesSBM" [value]="lang.codice">
                    <span class="fi fi-{{ lang.flagIcon }}"></span>
                    <span class="language-name">{{('language_codes.' + lang.codice) | translate}}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div class="font-small font-italic pr-1" *ngIf="nomeAlbergoVisible && !!sessionService.getUtente()">
            {{sessionService.getUtente()}}
        </div>
    </div>
</div>